<template>
  <div class="container container-footer bg-gray" :class="{ 'container-nav': !isMiniProgram }">
    <van-nav-bar v-if="!isMiniProgram" title="个人信息" left-arrow fixed :border=false :z-index="999" @click-left="goBack"/>
    <div v-else class="mini-back-bar" @click="goBack">
      <img class="mini-back-icon" src="../../assets/images/post/right_arrow.png" />
      <span>返回</span>
    </div>
    <section class="bg-white">
      <van-cell-group :border=false>
        <van-cell title="头像" class="all-c" is-link @click="chooseAvatar">
          <img class="photo-img" src="../../assets/images/common/user-photo.jpg"
               v-if="!avatarUrl"/>
          <img class="photo-img" :src="avatarUrl" v-else/>
        </van-cell>
        <van-cell title="微昵称" :value="nickname" is-link @click="editNickname"/>
        <van-cell title="姓名" :value="name" is-link @click="editName"/>
        <van-cell title="性别" :value="gender === 1 ? '男' : '女'" is-link @click="showGenderPicker = true"/>
        <van-cell title="生日" :value="birthdayStr" is-link @click="showBirthdayPicker = true"/>
        <van-cell title="手机号" :value="phone"/>
      </van-cell-group>
    </section>
    <section class="bg-white mt10">
      <van-cell-group :border=false>
        <!-- <van-cell title="擅长区域" :value="bestAreaStr" class="zdy-flex" is-link @click="go('my-area')"
                  value-class="txt-elips c-333"/> -->
        <van-cell title="擅长行业" :value="bestIndustryStr" class="zdy-flex" is-link @click="go('my-industry')"
                  value-class="txt-elips c-333"/>
      </van-cell-group>
    </section>

    <!-- 性别选择 -->
    <van-action-sheet
      v-model="showGenderPicker"
      :actions="genderActions"
      cancel-text="取消"
      @select="onGenderSelect"
    />

    <!-- 生日选择 -->
    <van-popup v-model="showBirthdayPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择生日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onBirthdayConfirm"
        @cancel="showBirthdayPicker = false"
      />
    </van-popup>

    <!-- 输入弹窗 -->
    <van-dialog
      v-model="showInputDialog"
      :title="inputDialogTitle"
      show-cancel-button
      @confirm="onInputConfirm"
    >
      <van-field
        v-model="inputValue"
        :placeholder="inputPlaceholder"
        class="mt10 mb10"
      />
    </van-dialog>
  </div>
</template>

<script>
  import api from '../../api';
  import { chooseImage, uploadImage } from '../../libs/native-app';
  import { getEnv } from '../../libs/util';
  
  export default {
    name: 'my-info',
    data() {
      return {
        vLeaderId: '',
        name: '',
        nickname: '',
        avatarUrl: '',
        verified: false,
        wxBind: false,
        gender: 1,
        birthday: '',
        phone: '',
        career: '',
        bestAreaList: [],
        bestAreaStr: '',
        interestedPositions: [],
        bestIndustryStr: '',
        // 性别选择
        showGenderPicker: false,
        genderActions: [
          { name: '男', value: 1 },
          { name: '女', value: 2 }
        ],
        // 生日选择
        showBirthdayPicker: false,
        currentDate: new Date(),
        minDate: new Date(1950, 0, 1),
        maxDate: new Date(),
        // 输入弹窗
        showInputDialog: false,
        inputDialogTitle: '',
        inputPlaceholder: '',
        inputValue: '',
        inputType: ''  // nickname, name, phone
      };
    },
    computed: {
      isMiniProgram() {
        return getEnv().envType === 'miniprogram';
      },
      birthdayStr() {
        if (this.birthday) {
          return this.birthday.substr(0, 10);
        }
        return '';
      }
    },
    mounted() {
      this.getLeaderInfo();
    },
    methods: {
      async getLeaderInfo() {
        try {
          let res = await api.get('/api/vpai/vleader/my_info');
          let data = res.data || res;

          this.vLeaderId = data.vLeaderId || '';
          this.name = data.name || '';
          this.nickname = data.nickname || '';
          this.avatarUrl = data.avatarUrl || '';
          this.verified = data.verified || false;
          this.wxBind = data.wxBind || false;
          this.gender = data.gender || 1;
          this.birthday = data.birthday || '';
          this.phone = data.phone || '';
          this.career = data.career || '';
          this.bestAreaList = data.bestAreaList || [];
          this.interestedPositions = data.interestedPositions || [];
          
          // 拼接擅长区域名称
          this.bestAreaStr = this.bestAreaList.join('、');
          // 拼接擅长行业名称（使用 interestedPositions）
          this.bestIndustryStr = this.interestedPositions.map(o => o.gwName).join('、');
          
          // 初始化生日选择器日期
          if (this.birthday) {
            this.currentDate = new Date(this.birthday);
          }
        } catch (e) {
          this.$toast(e.message);
        }
      },
      
      // 选择头像
      async chooseAvatar() {
        try {
          const result = await chooseImage();
          if (result) {
            this.$loading('上传中...');
            // 如果原生返回的已经是网络URL，直接使用
            let imageUrl = result;
            // 如果是本地路径，需要上传
            if (!result.startsWith('http')) {
              imageUrl = await uploadImage(result);
            }
            if (imageUrl) {
              this.avatarUrl = imageUrl;
              await this.saveInfo();
              this.$toast('修改成功');
            }
            this.$loadingClose();
          }
        } catch (e) {
          this.$loadingClose();
          this.$toast(e.message || '选择图片失败');
        }
      },
      
      // 编辑微昵称
      editNickname() {
        this.inputType = 'nickname';
        this.inputDialogTitle = '修改微昵称';
        this.inputPlaceholder = '请输入微昵称';
        this.inputValue = this.nickname;
        this.showInputDialog = true;
      },
      
      // 编辑姓名
      editName() {
        this.inputType = 'name';
        this.inputDialogTitle = '修改姓名';
        this.inputPlaceholder = '请输入姓名';
        this.inputValue = this.name;
        this.showInputDialog = true;
      },
      
      // 编辑手机号
      editPhone() {
        this.inputType = 'phone';
        this.inputDialogTitle = '修改手机号';
        this.inputPlaceholder = '请输入手机号';
        this.inputValue = this.phone;
        this.showInputDialog = true;
      },
      
      // 输入确认
      async onInputConfirm() {
        if (!this.inputValue.trim()) {
          this.$toast('请输入内容');
          return;
        }
        try {
          this[this.inputType] = this.inputValue.trim();
          await this.saveInfo();
          this.$toast('修改成功');
        } catch (e) {
          this.$toast(e.message);
        }
      },
      
      // 性别选择
      async onGenderSelect(action) {
        try {
          this.gender = action.value;
          await this.saveInfo();
          this.showGenderPicker = false;
          this.$toast('修改成功');
        } catch (e) {
          this.$toast(e.message);
        }
      },
      
      // 生日确认
      async onBirthdayConfirm(value) {
        try {
          const dateStr = this.formatDate(value);
          this.birthday = dateStr;
          await this.saveInfo();
          this.showBirthdayPicker = false;
          this.$toast('修改成功');
        } catch (e) {
          this.$toast(e.message);
        }
      },
      
      // 格式化日期
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      
      // 保存信息（提交所有字段）
      async saveInfo() {
        const params = {
          avatarUrl: this.avatarUrl || '',
          birthday: this.birthdayStr || '',
          career: this.career || '',
          gender: this.gender || 0,
          interestedPositions: this.interestedPositions || [],
          name: this.name || '',
          nickname: this.nickname || '',
          phone: this.phone || ''
        };
        await api.post('/api/vpai/vleader/improve_info', params);
      }
    }
  };
</script>

<style lang="less">
  @import '../../assets/css/theme.less';

  .photo-img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid @borderColor;
    vertical-align: middle;
    overflow: hidden;
  }

  .zdy-flex .van-cell__value {
    flex: 2;
  }

  .mini-back-bar {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background: #fff;
  }

  .mini-back-icon {
    width: 18px;
    height: 18px;
    margin-right: 4px;
    transform: rotate(180deg);
  }
</style>
